module.exports = __webpack_public_path__ + "static/media/galerija_2022_0010.d46da322.jpg";